// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"search__msignaturepad___21Rpu","m-signature-pad--body":"search__m-signature-pad--body___28TkX","m-signature-pad--footer":"search__m-signature-pad--footer___pztq1","description":"search__description___3bZ6l","button":"search__button___2Q_TQ","clear":"search__clear___3ht4S","save":"search__save___pJMlu","m-signature-pad":"search__m-signature-pad___3QWWK","github":"search__github___1elcR","wrapper":"search__wrapper___2ps4D","inputElement":"search__inputElement___2fqjY","submit":"search__submit___2Oh2C"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/NavigationBar/search.scss
// module id = 49Rk
// module chunks = client